import { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import algoliasearch from 'algoliasearch'
import { string, arrayOf, bool, number } from 'prop-types'
import { InstantSearch, Configure } from 'react-instantsearch'
import { algoliaAppId, algoliaSearchApiKey } from '../../../../lib/algolia'
import { createFilterQuery } from '../../../../lib/utils'
import CustomHits from '../../../AlgoliaComponents/CustomHits'
import ViewAllCTA from '../../Buttons/ViewAllCTA'
import SearchGridSectionItems from '../SearchGridSectionItems'

/** @todo: merge with GridSection (or visa versa) */
export default function SearchGridSection({
  testId = 'SearchGridSection',
  title,
  indexName,
  contentTypes,
  topics,
  keywords,
  authors,
  lowerDate,
  upperDate,
  featured,
  premium,
  elArticleType,
  ctaLink,
  ctaLabel,
  ctaTarget,
  totalLength,
  isAutoShowingCta,
  webinarMemberAuthentication,
}) {
  const searchClient = algoliasearch(algoliaAppId, algoliaSearchApiKey)
  const [showCta, setShowCta] = useState(false)

  //  View all button to show only when the available items are greater than the scroll by amount.
  // only applied for profile detail page
  useEffect(() => {
    const mediaTypes = ['video', 'webinar', 'podcast']
    const scrollByAmount = mediaTypes.includes(contentTypes?.[0]) ? 2 : 3

    setShowCta(isAutoShowingCta ? totalLength > scrollByAmount : true)
  }, [totalLength, isAutoShowingCta, contentTypes])
  return (
    <Box data-testid={testId}>
      <Box
        display='flex'
        justifyContent='space-between'
        alignItems='center'
        mb={2}
      >
        <Typography variant='h4' data-testid={`${testId}-title`}>
          {title}
        </Typography>
        {showCta && (
          <ViewAllCTA
            label={ctaLabel}
            href={ctaLink}
            target={ctaTarget}
            lg
            testId={testId}
          />
        )}
      </Box>
      <InstantSearch searchClient={searchClient} indexName={indexName}>
        <Configure
          filters={createFilterQuery(
            contentTypes,
            topics,
            keywords,
            authors,
            lowerDate,
            upperDate,
            featured,
            elArticleType,
            premium,
            webinarMemberAuthentication
          )}
          hitsPerPage={3}
        />
        <CustomHits CustomComponent={SearchGridSectionItems} />
      </InstantSearch>
    </Box>
  )
}

SearchGridSection.propTypes = {
  testId: string,
  title: string,
  indexName: string,
  contentTypes: arrayOf(string),
  topics: arrayOf(string),
  keywords: arrayOf(string),
  authors: arrayOf(string),
  lowerDate: string,
  upperDate: string,
  featured: bool,
  elArticleType: string,
  premium: bool,
  ctaLink: string,
  ctaLabel: string,
  ctaTarget: string,
  totalLength: number,
  isAutoShowingCta: bool,
  webinarMemberAuthentication: string,
}
